import axios from "axios";
import { del, get, post, put, patch } from "./api_helper";
import * as url from "./url_helper";

// Gets the logged in user data from local session
const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

//is user is logged in
const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

// Register Method
const postFakeRegister = data => {
  return axios
    .post(url.POST_FAKE_REGISTER, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data;
      throw response.data;
    })
    .catch(err => {
      let message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};

// Login Method

// postForgetPwd
const postFakeForgetPwd = data => post(url.POST_FAKE_PASSWORD_FORGET, data);

// Edit profile
const postJwtProfile = data => post(url.POST_EDIT_JWT_PROFILE, data);

const postFakeProfile = data => post(url.POST_EDIT_PROFILE, data);

// Register Method
const postJwtRegister = (url, data) => {
  return axios
    .post(url, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data;
      throw response.data;
    })
    .catch(err => {
      var message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};

// Login Method
const postJwtLogin = data => post(url.POST_FAKE_JWT_LOGIN, data);

// postForgetPwd
const postJwtForgetPwd = data => post(url.POST_FAKE_JWT_PASSWORD_FORGET, data);

// postSocialLogin
export const postSocialLogin = data => post(url.SOCIAL_LOGIN, data);

// get Products
export const getProducts = () => get(url.GET_PRODUCTS);

// get Product detail
export const getProductDetail = id =>
  get(`${url.GET_PRODUCTS_DETAIL}/${id}`, { params: { id } });

// get Events

// add Events

// update Event


// delete Event
export const deleteEvent = project =>
  del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteEventMega/${project}`);


// get Categories

// get chats

// get groups
export const getGroups = () => get(url.GET_GROUPS);

// get Contacts
export const getContacts = () => get(url.GET_CONTACTS);

// get messages


// post messages
export const getselectedmails = (selectedmails) => post(url.GET_SELECTED_MAILS, selectedmails);

//post setfolderonmails
export const setfolderonmails = (selectedmails, folderId, activeTab) => post(url.SET_FOLDER_SELECTED_MAILS, { selectedmails, folderId, activeTab });

// get orders
export const getOrders = () => get(url.GET_ORDERS);

// add order
export const addNewOrder = order => post(url.ADD_NEW_ORDER, order);

// update order
export const updateOrder = order => put(url.UPDATE_ORDER, order);

// delete order
export const deleteOrder = order =>
  del(url.DELETE_ORDER, { headers: { order } });

// get cart data
export const getCartData = () => get(url.GET_CART_DATA);

// get customers
export const getCustomers = () => get(url.GET_CUSTOMERS);

// add CUSTOMER
export const addNewCustomer = customer => post(url.ADD_NEW_CUSTOMER, customer);

// update CUSTOMER
export const updateCustomer = customer => put(url.UPDATE_CUSTOMER, customer);

// delete CUSTOMER
export const deleteCustomer = customer =>
  del(url.DELETE_CUSTOMER, { headers: { customer } });

// get shops
export const getShops = () => get(url.GET_SHOPS);

// get wallet
export const getWallet = () => get(url.GET_WALLET);

// get crypto order
export const getCryptoOrder = () => get(url.GET_CRYPTO_ORDERS);

// get crypto product
export const getCryptoProduct = () => get(url.GET_CRYPTO_PRODUCTS);

// get invoices
export const getInvoices = () => get(url.GET_INVOICES);

// get invoice details
export const getInvoiceDetail = id =>
  get(`${url.GET_INVOICE_DETAIL}/${id}`, { params: { id } });

// get jobs
export const getJobList = () => get(url.GET_JOB_LIST);

// get Apply Jobs
export const getApplyJob = () => get(url.GET_APPLY_JOB);

// get project
export const getProjects = () => get(url.GET_PROJECTS);

// get project details
export const getProjectsDetails = id =>
  get(`${url.GET_PROJECT_DETAIL}/${id}`, { params: { id } });

// get tasks
export const getTasks = () => get(url.GET_TASKS);

export const addSubEducation = user => post(`https://mansethaberadmin.stechomeyazilim.info:9096//addCampainHistoryCompany/send`, user);
export const updateSubEducation = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//updateSubEducationNefes/${user.ID}`, user);
export const deleteSubEducation = user => del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteSubEducation/${user}`);
export const addEducation = user => post(`https://mansethaberadmin.stechomeyazilim.info:9096//addEducationNefes/send`, user);
export const addProductCategory = user => post(`https://mansethaberadmin.stechomeyazilim.info:9096//addProductsCategoryLuxun/send`, user);
export const deleteProductCategory = user => del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteProductCategoryLuxun/${user}`);
export const updateProductCategory = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//updateProductCategoryLuxun/${user.ID}`, user);

export const addBlog = user => post(`https://mansethaberadmin.stechomeyazilim.info:9096//addBlogKupon/send`, user);
export const deleteBlog = project =>
  del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteBlogKupon/${project}`);
  export const updateBlog = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//updateBlogKupon/${user.ID}`, user);
  export const getBlogs = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getBlogKupon/select/`);
  

export const updateEducation = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//updateEducationNefes/${user.ID}`, user);

export const updateAbout = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//updateAboutKupon/${user.ID}`, user);
export const updateContact = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//updateContactPort/${user.ID}`, user);
export const getCategory = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getProductsCategoryLuxun/select/`);
export const getProducts1 = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getSmsKupon/select/`);


export const getAvailable = (sd,fd) => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getCampainHistoryDate/select/${sd}/${fd}`);
export const updateAvailable = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//updateAvailablePortsPort/${user.ID}`, user);
export const addAvailable = job => post(`https://mansethaberadmin.stechomeyazilim.info:9096//addAvailablePortsPort/send`, job);
export const deleteAvailable = project =>
del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteAvailablePortsPort/${project}`);
export const getSliders = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096/getSlider/select/`);

export const getSlider = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096/getSlider/select/`);

export const updateSlider = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096/updateSlider/${user.ID}`, user);

export const addSlider = job => post(`https://mansethaberadmin.stechomeyazilim.info:9096/addSlider/send`, job);

export const deleteSlider = project =>
  del(`https://mansethaberadmin.stechomeyazilim.info:9096/deleteSlider/${project}`);


export const getCampainCategory = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getCampainCategoryKupon/select/`);
export const updateCampainCategory = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//updateCampainCategoryKupon/${user.ID}`, user);
export const addCampainCategory = job => post(`https://mansethaberadmin.stechomeyazilim.info:9096//addCampainCategoryKupon/send`, job);
export const deleteCampainCategory= project =>
del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteCampainCategoryKupon/${project}`);



export const getCampain = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getCampainKupon/select/`);
export const updateCampain= user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//updateCampainKupon/${user.ID}`, user);
export const addCampain = job => post(`https://mansethaberadmin.stechomeyazilim.info:9096//addCampainKupon/send`, job);

export const deleteCampain= project =>
del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteCampainKupon/${project}`);


export const getEducationSubItem = user => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getCampainHistoryKuponFilter/select/${user}`);

export const getCampainHistory = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getCampain_HistoryKupon/select/`);
export const updateCampainHistory= user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//updateCampain_HistoryKupon/${user.ID}`, user);
export const addCampainHistory = job => post(`https://mansethaberadmin.stechomeyazilim.info:9096//addCampain_HistoryKupon/send`, job);

export const deleteCampainHistory= project =>
del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteCampain_HistoryKupon/${project}`);


export const getJob = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getJobKupon/select/`);
export const updateJob= user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//updateJobKupon/${user.ID}`, user);
export const addJob = job => post(`https://mansethaberadmin.stechomeyazilim.info:9096//addJobKupon/send`, job);
export const deleteJob= project =>
del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteJobKupon/${project}`);

export const getSector = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getSectorKupon/select/`);
export const updateSector= user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//updateSectorKupon/${user.ID}`, user);
export const deleteSector= project =>
del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteSectorKupon/${project}`);

export const addSector = job => post(`https://mansethaberadmin.stechomeyazilim.info:9096//pushnotificationKupon/send`, job);


export const getCampainPeriod = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getCampaign_PeriodKupon/select/`);
export const updateCampainPeriod= user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//updateCampaign_PeriodKupon/${user.ID}`, user);
export const addCampainPeriod= job => post(`https://mansethaberadmin.stechomeyazilim.info:9096//Campaign_PeriodKupon/send`, job);
export const deleteCampainPeriod= project =>
del(`https://mansethaberadmin.stechomeyazilim.info:9096//Campaign_PeriodKupon/${project}`);


export const getSubSector = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getSubSectorKupon/select/`);
export const updateSubSector= user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//updateSubSectorKupon/${user.ID}`, user);
export const addSubSector = job => post(`https://mansethaberadmin.stechomeyazilim.info:9096//addSubSectorKupon/send`, job);
export const deleteSubSector= project =>
del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteSubSectorKupon/${project}`);

export const getCompany = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getCompanyKupon/select/`);
export const updateCompany = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//updateCompanyKupon/${user.ID}`, user);
export const addCompany= job => post(`https://mansethaberadmin.stechomeyazilim.info:9096//addCompanyKupon/send`, job);
export const deleteCompany= project =>
del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteCompanyKupon/${project}`);



export const getFeedBack = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getFeedBackKupon/select/`);
export const updateFeedBack = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//updateFeedBackKupon/${user.ID}`, user);
export const addFeedBack= job => post(`https://mansethaberadmin.stechomeyazilim.info:9096//addFeedBackKupon/send`, job);
export const deleteFeedBack= project =>
del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteFeedBackKupon/${project}`);


export const getBlogCat = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getCampainCompany/select/`);
export const updateBlogCat = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//updateBlogCategoryMSE/${user.ID}`, user);
export const addBlogCat = job => post(`https://mansethaberadmin.stechomeyazilim.info:9096//addBlogCategoryMSE/send`, job);
export const deleteBlogCat= project =>
del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteBlogCategoryMSE/${project}`);



export const getWebApp = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getWebAppKupon/select/`);
export const updateWebApp = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//updateWebAppKupon/${user.ID}`, user);
export const addWebApp = job => post(`https://mansethaberadmin.stechomeyazilim.info:9096//addWebAppKupon/send`, job);
export const deleteWebApp= project =>
del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteWebAppKupon/${project}`);



export const getBlogSubCat = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getSubCategoryMSE/select/`);
export const updateBlogSubCat = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//updateSubCategoryMSE/${user.ID}`, user);
export const addBlogSubCat = job => post(`https://mansethaberadmin.stechomeyazilim.info:9096//addSubCategoryMSE/send`, job);
export const deleteBlogSubCat= project =>
del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteBlogSubCategoryMSE/${project}`);


export const getFeedBackCategory = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getFeedBackCategoryKupon/select/`);

export const getCompanyReferanceCode = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getCompanyReferanceCode/select/`);
export const updateCompanyReferanceCode = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//updateCompanyReferanceCode/${user.ID}`, user);
export const updateFeedbackCategory = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//updateFeedbackCategory/${user.ID}`, user);
export const addFeedBackCategory= job => post(`https://mansethaberadmin.stechomeyazilim.info:9096//addFeedBackCategory/send`, job);
export const deleteFeedBackCategory= project =>
del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteFeedBackCategory/${project}`);

export const addCompanyReferanceCode= job => post(`https://mansethaberadmin.stechomeyazilim.info:9096//addCompanyReferanceCode/send`, job);
export const deleteCompanyReferanceCode= project =>
del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteCompanyReferanceCode/${project}`);

export const deleteAuth= project =>
del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteAuthKupon/${project}`);

export const getAdvert = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getAdvertTekneport/select/`);
export const updateAdvert = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//updateTekneportAdvert/${user.ID}`, user);
export const addAdvert= job => post(`https://mansethaberadmin.stechomeyazilim.info:9096//addAdvertTekneport/send`, job);
export const deleteAdvert= project =>
del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteAdvertPortsPort/${project}`);



export const getReservation = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getReservationPort/select/`);
export const updateReservation = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//updateSliderPort/${user.ID}`, user);
export const addReservation = job => post(`https://mansethaberadmin.stechomeyazilim.info:9096//addSliderPort/send`, job);
export const deleteReservation = project =>
del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteSSSPort/${project}`);


export const getOffer = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getOfferPort/select/`);
export const updateOffer = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//updateSliderPort/${user.ID}`, user);
export const addOffer = job => post(`https://mansethaberadmin.stechomeyazilim.info:9096//addSliderPort/send`, job);
export const deleteOffer = project =>
del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteSSSPort/${project}`);



export const getSSS = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getSSSKupon/select/`);
const LOCAL_ADMIN_USERS = [
  {
    email: "bilgi@stechome.com.tr",
    password: "123321ee",
    user: {
      ID: 0,
      Users_MailAddress: "bilgi@stechome.com.tr",
      Users_NameSurname: "Stechome Admin",
      Users_Role: "admin",
    },
  },
];

const postFakeLogin = data => {
  const localMatch = LOCAL_ADMIN_USERS.find(
    u => u.email === data.email && u.password === data.password
  );
  if (localMatch) {
    return Promise.resolve({ value: [localMatch.user] });
  }
  const params = new URLSearchParams();
  params.set('$filter', `Users_MailAddress eq '${data.email}' and Users_Password eq '${data.password}'`);
  params.set('$format', 'json');
  return get(`https://mansethaberapi.stechomeyazilim.com/Users?${params.toString()}`);
};

export const getUsers = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096/getAllNews/select/`);
export const deleteUser = user => del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteUsersKupon/${user}`);
export const getProjectsNew = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getEducationNefes/select/`);
export const getEducation = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getEducationNefes/select/`);

export const getPopup = user => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getUserCompanyKupon/select/${user}`);

export const getWorkShop = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getSUBDOMAINMega/select/`);

export const getCourseSchedulesMega = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getCourseSchedulesMega/select/`);

export const getWorkshopSessionMega = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getWorkshopSessionMega/select/`);

export const getTeacherMega = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getNotificationKupon/select/`);

export const getEventMega = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getEventMega/select/`);

export const getDynamicFormMega = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getCompanyReferanceCode/select/`);

export const addDynamicForm = job => post(`https://mansethaberadmin.stechomeyazilim.info:9096//addCompanyReferanceCode/send`, job);

export const updateDynamicForm = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//updateCompanyReferanceCode/${user.ID}`, user);

export const deleteDynamicForm = project =>
  del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteCompanyReferanceCode/${project}`);


export const getNews = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getNewsMega/select/`);

export const getMegaMega = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getMegaMega/select/`);

export const getMailsLists = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getContactMessageMega/select/`);

// add user


export const getEvents = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getEventMega/select/`);
export const getAbout = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getAboutKupon/select/`);
export const getCategories = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getEventCategoryMega/select/`);
// update user

export const getSubs= () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getSubscriptionUser/select/`);

export const updateSubDomain = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//patchSUBDOMAINMega/${user.ID}`, user);

export const updateCourseSchedules = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//patchCourseSchedulesMega/${user.ID}`, user);

export const updateWorkshopSession = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//patchWorkShopSessionMega/${user.ID}`, user);

export const updateTeacher = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//patchUserMega/${user.ID}`, user);

export const updateSSS = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//updateSSSKupon/${user.ID}`, user);

export const updateProduct = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//updateProductLuxun/${user.ID}`, user);

export const updateUser = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//updateUsersKupon/${user.ID}`, user);

export const updatePopup = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//updateUsersKupon/${user.ID}`, user);

export const addPopup = job => post(`https://mansethaberadmin.stechomeyazilim.info:9096//addUsersKupon/send`, job);

export const deletePopup = project =>
  del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteUsersKupon/${project}`);


export const updateProject = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//patchUpdateProject/${user.ID}`, user);

export const updateNews = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//patchNews/${user.ID}`, user);

export const addSSS= job => post(`https://mansethaberadmin.stechomeyazilim.info:9096//addSSSKupon/send`, job);
export const addProduct = job => post(`https://mansethaberadmin.stechomeyazilim.info:9096//addProductLuxun/send`, job);
export const addUser = job => post(`https://mansethaberadmin.stechomeyazilim.info:9096//addUsersKupon/insert`, job);
export const addNewUser = user => post(`https://mansethaberadmin.stechomeyazilim.info:9096//addGroupTypeKupon/send`, user);


export const addProject = job => post(`https://mansethaberadmin.stechomeyazilim.info:9096//addProject/send`, job);

export const addNews = job => post(`https://mansethaberadmin.stechomeyazilim.info:9096//addNews/send`, job);

export const addMega = job => post(`https://mansethaberadmin.stechomeyazilim.info:9096//addMega/send`, job);

export const addCourseMega = job => post(`https://mansethaberadmin.stechomeyazilim.info:9096//addCourseMega/send`, job);

export const updateSubdomain = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//patchSUBDOMAINMega/${user.ID}`, user);




export const updateMega = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//patchMegaMega/${user.ID}`, user);

export const updateGallery = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//patchGalleryMega/${user.ID}`, user);

export const updateEvent = event => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//patchEventMega/${event.ID}`, event);

export const addAppSetting = job => post(`https://mansethaberadmin.stechomeyazilim.info:9096//postWSMega/send`, job);

export const addWorkshop2 = job => post(`https://mansethaberadmin.stechomeyazilim.info:9096//postWorkshopMega/send`, job);



// delete user

export const getContact = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getContactPort/select/`);
export const getWorkshop2 = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getWorkshopMega/select/`);

export const updateWorkShop2 = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//patchWorkshop2Mega/${user.ID}`, user);

export const getGallery = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getGalleryMega/select/`);

export const addNewEvent = event => post(`https://mansethaberadmin.stechomeyazilim.info:9096//postEventMega/send/`, event);

export const getChats = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getContactMessageMega/select/`);

export const getMessages = (roomId = "") => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getContactMessageDetailMega/select/${roomId}`);

export const addNewSubdomain = event => post(`https://mansethaberadmin.stechomeyazilim.info:9096//postSubdomainMega/send/`, event);
export const getReferances = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getReferancesMega/select/`);
// add jobs
export const addNewJobList = job => post(url.ADD_NEW_JOB_LIST, job);
// update jobs
export const updateJobList = job => put(url.UPDATE_JOB_LIST, job);
// delete jobs
export const deleteJobList = job => del(url.DELETE_JOB_LIST, { headers: { job } });
// Delete Apply Jobs
export const deleteApplyJob = data => del(url.DELETE_APPLY_JOB, { headers: { data } });
/** PROJECT */
// add user
export const addNewProject = project => post(url.ADD_NEW_PROJECT, project);


export const addReferances = event => post(`https://mansethaberadmin.stechomeyazilim.info:9096//postReferancesMega/send/`, event);

export const updateReferances = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//patchReferancesMega/${user.ID}`, user);

export const getSubProject = (ID = "") => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getProjectSubItem/select/${ID}`);

export const getTeacherWorkshop = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getTeacherWorkshopMega/select/`);

export const addLessonsTime = event => post(`https://mansethaberadmin.stechomeyazilim.info:9096//postLessonsTimeMega/send/`, event);

export const updateLessonsTime = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//patchTeacherWorkshopMega/${user.ID}`, user);

export const getClassAttendance = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getClassAttendanceMega/select/`);

export const getClassesMega = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getClassesMega/select/`);


export const getDynamicFormExtraMega = (ID = "") => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getDynamicFormExtraMega/select/${ID}`);

export const getDynamicFormExtraExtraMega = (ID = "") => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getDynamicFormExtraExtraMega/select/${ID}`);


export const addGallerry = job => post(`https://mansethaberadmin.stechomeyazilim.info:9096//postGalleryMega/send`, job);

export const addMultipleGalleryForm = job => post(`https://mansethaberadmin.stechomeyazilim.info:9096//postGalleryMultipleMega/send`, job);


export const deleteDynamicFormExtraExtra = project =>
  del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteDynamicExtraExtraFormMega/${project}`);


export const deleteDynamicFormExtra = project =>
  del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteDynamicFormExtraMega/${project}`);

export const deleteCourseSchedules = project =>
  del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteCourseSchedulesMega/${project}`);

export const deleteGallery = project =>
  del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteGalleryMega/${project}`);

export const deleteReferances = project =>
  del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteReferancesMega/${project}`);


  export const getAuthority = () => get(`https://mansethaberadmin.stechomeyazilim.info:9096//getGroupTypeKupon/select/`);
  export const updateAuth = user => patch(`https://mansethaberadmin.stechomeyazilim.info:9096//updateGroupTypeKupon/${user.ID}`, user);

  
  export const deleteSSS = project =>
  del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteSSSKupon/${project}`);
  


export const deleteProduct = project =>
del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteProductLuxun/${project}`);


  

export const deleteNews = project =>
  del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteNewsMega/${project}`);

export const deleteMega = project =>
  del(`https://mansethaberadmin.stechomeyazilim.info:9096//deleteMega/${project}`);

export const deleteProject = project =>
  del(url.DELETE_PROJECT, { headers: { project } });

export const getUserProfile = () => get(url.GET_USER_PROFILE);

//update mail
export const updateMail = mail => put(url.UPDATE_MAIL, mail);

// get folderlist
export const selectFolders = () => get(url.SELECT_FOLDER);

// post messages
export const addMessage = message => post(url.ADD_MESSAGE, message);

// get dashboard charts data
export const getWeeklyData = () => get(url.GET_WEEKLY_DATA);
export const getYearlyData = () => get(url.GET_YEARLY_DATA);
export const getMonthlyData = () => get(url.GET_MONTHLY_DATA);

export const walletBalanceData = month =>
  get(`${url.GET_WALLET_DATA}/${month}`, { params: { month } });

export const getStatisticData = duration =>
  get(`${url.GET_STATISTICS_DATA}/${duration}`, { params: { duration } });

export const visitorData = duration =>
  get(`${url.GET_VISITOR_DATA}/${duration}`, { params: { duration } });

export const topSellingData = month =>
  get(`${url.TOP_SELLING_DATA}/${month}`, { params: { month } });

export const getEarningChartsData = month =>
  get(`${url.GET_EARNING_DATA}/${month}`, { params: { month } });

const getProductComents = () => get(url.GET_PRODUCT_COMMENTS);

const onLikeComment = (commentId, productId) => {
  return post(`${url.ON_LIKNE_COMMENT}/${productId}/${commentId}`, {
    params: { commentId, productId },
  });
};
const onLikeReply = (commentId, productId, replyId) => {
  return post(`${url.ON_LIKNE_COMMENT}/${productId}/${commentId}/${replyId}`, {
    params: { commentId, productId, replyId },
  });
};

const onAddReply = (commentId, productId, replyText) => {
  return post(`${url.ON_ADD_REPLY}/${productId}/${commentId}`, {
    params: { commentId, productId, replyText },
  });
};

const onAddComment = (productId, commentText) => {
  return post(`${url.ON_ADD_COMMENT}/${productId}`, {
    params: { productId, commentText },
  });
};

export {
  getLoggedInUser,
  isUserAuthenticated,
  postFakeRegister,
  postFakeLogin,
  postFakeProfile,
  postFakeForgetPwd,
  postJwtRegister,
  postJwtLogin,
  postJwtForgetPwd,
  postJwtProfile,
  getProductComents,
  onLikeComment,
  onLikeReply,
  onAddReply,
  onAddComment,
};